import { Injectable } from '@angular/core';
import { StripeConfig } from './config';
import { StripeService } from './stripe.service';
import { StripePaymentElement } from '@stripe/stripe-js/types/stripe-js/elements';
import { Observable } from 'rxjs';
import { StripeElements } from '@stripe/stripe-js';
import { map } from 'rxjs/operators';

@Injectable()
export class StripeElementsService {
  elements!: StripeElements;

  constructor(
    private readonly stripeService: StripeService,
    private readonly stripeConfig: StripeConfig
  ) {}

  create$(clientSecret: string): Observable<StripePaymentElement> {
    return this.stripeService.stripe
      .elements({
        allowedCardBrands: this.stripeConfig.allowedCardBrands,
        appearance: this.stripeConfig.appearance,
        fonts: this.stripeConfig.fonts,
        clientSecret,
      })
      .pipe(
        map((elements) => {
          this.elements = elements;

          const paymentElement = elements.create('payment', { layout: 'tabs' });

          paymentElement.mount('#' + this.stripeConfig.elementId);

          return paymentElement;
        })
      );
  }
}
